export const NoCache = () => (target) => {
    target.prototype.noCache = true;
    return target;
};
